import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    getBrand() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/brand/web/getbrand",
          method: "GET"
        }).then(response => {
          if (response.data.status) {
            resolve(response);
          }
          reject(response);
        }).catch(error => {
          reject(error);
        })
      });
    },
    updateBrand(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + "/brand/web/update",
          method: "PUT",
          data: obj
        }).then(response => {
          if (response.data.status) {
            resolve(response);
          }
          reject(response);
        }).catch(error => {
          reject(error);
        })
      });
    }
  }
};